
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5tKh7", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $jmjWc = parcelRequire("jmjWc");








var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $6mKj3 = parcelRequire("6mKj3");


var $7aRa9 = parcelRequire("7aRa9");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4e2549f598bdb9fe$var$Placeholder = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(8);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { dynamicCoverImageHeight: dynamicCoverImageHeight, ...__cmpldp } = __cmplp;
        const t3 = `${__cmplp.dynamicCoverImageHeight}px`;
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $9aYkv.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let t5;
        if ($[5] !== __cmpls || $[6] !== t4) {
            t5 = {
                ...__cmpls,
                "--_1isxe5u": t4
            };
            $[5] = __cmpls;
            $[6] = t4;
            $[7] = t5;
        } else t5 = $[7];
        t1 = /*#__PURE__*/ $cozmU.createElement(C, {
            ...__cmpldp,
            style: t5,
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_2uo31fmhAQ _0bjKvDzXzM _1mT5xdRAKS _39xV02N91d _0jFU0Vc2HY",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $4e2549f598bdb9fe$var$placeholderStyles = null;
const $4e2549f598bdb9fe$export$6ab910d41613f405 = (0, $7aRa9.withFlags)((props)=>{
    if (!props.hasCoverPicture) return null;
    if ((0, $6mKj3.expValEquals)('confluence_page_cover_picture_css_migration', 'isEnabled', true)) return /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            height: props.dynamicCoverImageHeight ? `${props.dynamicCoverImageHeight}px` : undefined
        },
        className: (0, $hekY6.default)([
            "_0bjKvDKxmn _1mT5xdRAKS _0KLXrumhAQ _39xV02N91d"
        ])
    });
    return /*#__PURE__*/ $cozmU.createElement($4e2549f598bdb9fe$var$Placeholder, null);
});



const $7cc006105e2a4093$export$cc835f6c4a40c9c0 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "6TpAT",
    name: "LazyEditorPageCoverPicture",
    loader: async ()=>{
        return (await (parcelRequire("fXp9F"))).EditorPageCoverPicture;
    },
    loading: (0, $4e2549f598bdb9fe$export$6ab910d41613f405)
});



var $i5zxs = parcelRequire("i5zxs");

const $fdbc267ab6414ddb$var$EditorPageCoverPictureEntryComponent = (t0)=>{
    const $ = (0, $bDgLe.c)(47);
    const { contentId: contentId, isPublishingContent: isPublishingContent, contentType: contentType, userOffline: userOffline, coverPictureState: coverPictureState, isUnpublishedDraft: isUnpublishedDraft, floatingToolbarButtonStyle: floatingToolbarButtonStyle, isFixedWidthImageOption: isFixedWidthImageOption, width: width, dynamicCoverImageHeight: dynamicCoverImageHeight, isReadOnly: isReadOnly, hasCoverPicture: hasCoverPicture, contentPropertyKey: contentPropertyKey, isSmartSpaceOverview: isSmartSpaceOverview, isUnsplash: isUnsplash, aiHeaderImageStatus: aiHeaderImageStatus, aiHeaderImageFileId: aiHeaderImageFileId, aiHeaderImageError: aiHeaderImageError, generateAIHeaderImage: generateAIHeaderImage, setAIHeaderImageStatus: setAIHeaderImageStatus, isSmartCreate: isSmartCreate } = t0;
    if (hasCoverPicture) {
        const t1 = isFixedWidthImageOption ? "relative" : "absolute";
        let t2;
        if ($[0] !== t1) {
            t2 = {
                position: t1,
                left: "0px",
                right: "0px"
            };
            $[0] = t1;
            $[1] = t2;
        } else t2 = $[1];
        let t3;
        if ($[2] !== aiHeaderImageError || $[3] !== aiHeaderImageFileId || $[4] !== aiHeaderImageStatus || $[5] !== contentId || $[6] !== contentPropertyKey || $[7] !== contentType || $[8] !== coverPictureState || $[9] !== dynamicCoverImageHeight || $[10] !== floatingToolbarButtonStyle || $[11] !== generateAIHeaderImage || $[12] !== hasCoverPicture || $[13] !== isFixedWidthImageOption || $[14] !== isPublishingContent || $[15] !== isReadOnly || $[16] !== isSmartCreate || $[17] !== isSmartSpaceOverview || $[18] !== isUnpublishedDraft || $[19] !== isUnsplash || $[20] !== setAIHeaderImageStatus || $[21] !== userOffline || $[22] !== width) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7cc006105e2a4093$export$cc835f6c4a40c9c0), {
                contentId: contentId,
                isPublishingContent: isPublishingContent,
                contentType: contentType,
                userOffline: userOffline,
                hasCoverPicture: hasCoverPicture,
                contentPropertyKey: contentPropertyKey,
                isSmartSpaceOverview: isSmartSpaceOverview,
                coverPictureState: coverPictureState,
                isUnpublishedDraft: isUnpublishedDraft,
                floatingToolbarButtonStyle: floatingToolbarButtonStyle,
                width: width,
                dynamicCoverImageHeight: dynamicCoverImageHeight,
                isReadOnly: isReadOnly,
                isUnsplash: isUnsplash,
                isFixedWidthImageOption: isFixedWidthImageOption,
                aiHeaderImageStatus: aiHeaderImageStatus,
                aiHeaderImageFileId: aiHeaderImageFileId,
                aiHeaderImageError: aiHeaderImageError,
                generateAIHeaderImage: generateAIHeaderImage,
                isSmartCreate: isSmartCreate,
                setAIHeaderImageStatus: setAIHeaderImageStatus
            });
            $[2] = aiHeaderImageError;
            $[3] = aiHeaderImageFileId;
            $[4] = aiHeaderImageStatus;
            $[5] = contentId;
            $[6] = contentPropertyKey;
            $[7] = contentType;
            $[8] = coverPictureState;
            $[9] = dynamicCoverImageHeight;
            $[10] = floatingToolbarButtonStyle;
            $[11] = generateAIHeaderImage;
            $[12] = hasCoverPicture;
            $[13] = isFixedWidthImageOption;
            $[14] = isPublishingContent;
            $[15] = isReadOnly;
            $[16] = isSmartCreate;
            $[17] = isSmartSpaceOverview;
            $[18] = isUnpublishedDraft;
            $[19] = isUnsplash;
            $[20] = setAIHeaderImageStatus;
            $[21] = userOffline;
            $[22] = width;
            $[23] = t3;
        } else t3 = $[23];
        let t4;
        if ($[24] !== t2 || $[25] !== t3) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                "data-testid": "has-cover-picture-component",
                style: t2
            }, t3);
            $[24] = t2;
            $[25] = t3;
            $[26] = t4;
        } else t4 = $[26];
        return t4;
    }
    let t1;
    if ($[27] !== aiHeaderImageError || $[28] !== aiHeaderImageFileId || $[29] !== aiHeaderImageStatus || $[30] !== contentId || $[31] !== contentPropertyKey || $[32] !== contentType || $[33] !== coverPictureState || $[34] !== dynamicCoverImageHeight || $[35] !== floatingToolbarButtonStyle || $[36] !== generateAIHeaderImage || $[37] !== hasCoverPicture || $[38] !== isPublishingContent || $[39] !== isReadOnly || $[40] !== isSmartCreate || $[41] !== isSmartSpaceOverview || $[42] !== isUnpublishedDraft || $[43] !== setAIHeaderImageStatus || $[44] !== userOffline || $[45] !== width) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": "no-cover-picture-component"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7cc006105e2a4093$export$cc835f6c4a40c9c0), {
            contentId: contentId,
            isPublishingContent: isPublishingContent,
            contentType: contentType,
            userOffline: userOffline,
            hasCoverPicture: hasCoverPicture,
            contentPropertyKey: contentPropertyKey,
            isSmartSpaceOverview: isSmartSpaceOverview,
            coverPictureState: coverPictureState,
            isUnpublishedDraft: isUnpublishedDraft,
            floatingToolbarButtonStyle: floatingToolbarButtonStyle,
            width: width,
            dynamicCoverImageHeight: dynamicCoverImageHeight,
            isReadOnly: isReadOnly,
            aiHeaderImageStatus: aiHeaderImageStatus,
            aiHeaderImageFileId: aiHeaderImageFileId,
            aiHeaderImageError: aiHeaderImageError,
            generateAIHeaderImage: generateAIHeaderImage,
            setAIHeaderImageStatus: setAIHeaderImageStatus,
            isSmartCreate: isSmartCreate
        }));
        $[27] = aiHeaderImageError;
        $[28] = aiHeaderImageFileId;
        $[29] = aiHeaderImageStatus;
        $[30] = contentId;
        $[31] = contentPropertyKey;
        $[32] = contentType;
        $[33] = coverPictureState;
        $[34] = dynamicCoverImageHeight;
        $[35] = floatingToolbarButtonStyle;
        $[36] = generateAIHeaderImage;
        $[37] = hasCoverPicture;
        $[38] = isPublishingContent;
        $[39] = isReadOnly;
        $[40] = isSmartCreate;
        $[41] = isSmartSpaceOverview;
        $[42] = isUnpublishedDraft;
        $[43] = setAIHeaderImageStatus;
        $[44] = userOffline;
        $[45] = width;
        $[46] = t1;
    } else t1 = $[46];
    return t1;
};
const $fdbc267ab6414ddb$export$e8a47c72fec9e984 = (props)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            (0, $i5zxs.CoverPictureStateContainer)
        ];
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: t0
        }, (coverPictureState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fdbc267ab6414ddb$var$EditorPageCoverPictureEntryComponent, {
                ...props,
                coverPictureState: coverPictureState
            })));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
module.exports["EditorPageCoverPictureEntry"] = $fdbc267ab6414ddb$export$e8a47c72fec9e984;

});

parcelRegister("fXp9F", function(module, exports) {

let $b9dfe0ee745913c2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b9dfe0ee745913c2$var$load("6T9n5"),
    $b9dfe0ee745913c2$var$load("c9e1W"),
    $b9dfe0ee745913c2$var$load("bfTdl"),
    $b9dfe0ee745913c2$var$load("2cSY3"),
    $b9dfe0ee745913c2$var$load("4izLy"),
    $b9dfe0ee745913c2$var$load("vsgOr"),
    $b9dfe0ee745913c2$var$load("i313S"),
    $b9dfe0ee745913c2$var$load("6OMo6"),
    $b9dfe0ee745913c2$var$load("aaRXj"),
    $b9dfe0ee745913c2$var$load("fHlIz"),
    $b9dfe0ee745913c2$var$load("4QwAJ"),
    $b9dfe0ee745913c2$var$load("3i44s"),
    $b9dfe0ee745913c2$var$load("5kI0b"),
    $b9dfe0ee745913c2$var$load("kYkz1"),
    $b9dfe0ee745913c2$var$load("jfYeU"),
    $b9dfe0ee745913c2$var$load("b4nm1"),
    $b9dfe0ee745913c2$var$load("geXPZ"),
    $b9dfe0ee745913c2$var$load("aQ5uu"),
    $b9dfe0ee745913c2$var$load("6wr18"),
    $b9dfe0ee745913c2$var$load("dlm6q"),
    $b9dfe0ee745913c2$var$load("7H1j2"),
    $b9dfe0ee745913c2$var$load("jfSwd"),
    $b9dfe0ee745913c2$var$load("cmmpX"),
    $b9dfe0ee745913c2$var$load("el56J"),
    $b9dfe0ee745913c2$var$load("cByHu"),
    $b9dfe0ee745913c2$var$load("iWnyc"),
    $b9dfe0ee745913c2$var$load("ea3NB"),
    $b9dfe0ee745913c2$var$load("1oKjW"),
    $b9dfe0ee745913c2$var$load("excC5"),
    $b9dfe0ee745913c2$var$load("ffEVr"),
    $b9dfe0ee745913c2$var$load("6vqGz"),
    $b9dfe0ee745913c2$var$load("kGmwI"),
    $b9dfe0ee745913c2$var$load("Wowvf"),
    $b9dfe0ee745913c2$var$load("uvm9i"),
    $b9dfe0ee745913c2$var$load("7EorR"),
    $b9dfe0ee745913c2$var$load("hhss7"),
    $b9dfe0ee745913c2$var$load("aAWLw"),
    $b9dfe0ee745913c2$var$load("gGhXk")
]).then(()=>parcelRequire('4hoOb'));

});


//# sourceMappingURL=EditorPageCoverPictureEntry.926a1c94.js.map
